import { defineComponent as _defineComponent } from 'vue'
import { useUserStore } from "@/stores/user";
import { computed } from "vue";
import routesName from "@/utils/constants/routesName";
import logoSrc from "@/assets/images/logo.svg";
import useDayjs from "@/composables/useDayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();
const isLoggedIn = computed(() => !!userStore.accessToken);

const { dayjs } = useDayjs();
const currentYear = dayjs().format("YYYY");

const __returned__ = { userStore, isLoggedIn, dayjs, currentYear, get useUserStore() { return useUserStore }, computed, get routesName() { return routesName }, get logoSrc() { return logoSrc }, get useDayjs() { return useDayjs } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})